export default class FreeInputWinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());

		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}

		this.slotControls.setSpinButtonText(this.slotControls.freeSpins > 0 ? this.slotControls.freeSpins : 'SPIN');
		this.setInputActivity();
		this.stateObject.freeInputWinShow(needSpin => {
			if (needSpin) this.stateMachine.changeState(this.stateObject.preSpinState);
		});
	}

	exitTo(newState) {
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.setInputActivity();
		} else if (this.slotControls.holdToAutoSpin) {
			this.slotControls.setAutoSpinsMode();
			this.stateMachine.changeState(this.stateObject.preSpinState);
		}
	}

	spin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.setInputActivity();
		} else {
			this.stateMachine.changeState(this.stateObject.preSpinState);
		}
	}

	autoSpin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.setInputActivity();
		} else {
			this.slotControls.setAutoSpinsMode();
			this.stateMachine.changeState(this.stateObject.preSpinState);
		}
	}
	//endregion input

	setInputActivity() {
		if (this.slotControls.hasFreeSpin() && this.slotControls.autoPlayFreeSpins)
			this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		else if (this.slotControls.hasFreeSpin() && !this.slotControls.autoPlayFreeSpins)
			this.slotControls.setControlActivity(false, true, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		else if (this.slotControls.auto) {
			this.slotControls.setControlActivity(false, true, true); // activity, spinButtonAcivity, autoSpinButtonAcivity
		} else this.slotControls.setControlActivity(true, true, true); // activity, spinButtonAcivity, autoSpinButtonAcivity
	}

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'FreeInputWinState';
	}
}
